<div class="flex bg-gray-100 rounded-full items-center justify-between pr-4 mx-4">
    <input type="text"
        class="bg-transparent outline-none w-full placeholder:text-[#475569] placeholder:text-sm py-4 px-5"
        placeholder="{{ 'common.modals.ai-actions.content.message.placeholder' | translate }}" [(ngModel)]="message"
        (keyup.enter)="onEnter()" (focus)="onInputFocus()" (blur)="onInputBlur()">
    <button class="bg-transparent rounded-full size-9 shrink-0 cursor-pointer flex items-center justify-center"
        (click)="onSendButtonClick()">
        <vw-icon-svg iconUrl="/assets/svg/send.svg" width="24px" height="24px"></vw-icon-svg>
    </button>
</div>
